import React, { Component, } from 'react'

class fullReplacementLink extends Component {
    constructor(props){
        super(props)
        this.handleClick = this.handleClick.bind(this)
    }

    handleClick(){
        let currentURL = window.location.href
        if(currentURL.includes("#main-content")){
            let originalURL = currentURL.replace("#main-content", "")
            let newURL = originalURL + "fullReplacementPage"
            window.location.assign(newURL)
        }else{
            let newURL = currentURL + "fullReplacementPage"
            window.location.assign(newURL)
        }
    }

    render() {
        return (
            <li><strong><p><button type="button" className="linkButton" onClick={this.handleClick} tabIndex="0" >Upload Full Replacement File</button></p></strong>
            </li>
        )
    }
}
export default fullReplacementLink